<script setup>
import { ref } from "vue";
import Tiptap from "../forms/Tiptap.vue";

const props = defineProps([
    "whiteboardUrl",
    "context",
    "isEdit",
    "playApi",
    "playbookApi",
    "previewUrl",
    "whiteboardApi",
    "hideAttachments",
    "sport",
]);
const isReplying = ref(props.isEdit ?? false);
</script>

<template>
    <div v-if="isReplying">
        <Tiptap
            :context="context"
            :whiteboard-url="whiteboardUrl"
            :is-edit="isEdit"
            :play-api="playApi"
            :playbook-api="playbookApi"
            :preview-url="previewUrl"
            :whiteboard-api="whiteboardApi"
            :hide-attachments="hideAttachments"
            :sport="sport"
            name="content"
            placeholder="Write your reply ..."
        ></Tiptap>
    </div>
    <div v-else>
        <button
            type="button"
            class="
                bg-transparent
                outline-none
                hover:text-opacity-50
                font-semibold
                text-accent
            "
            @click="isReplying = true"
        >
            Reply
        </button>
    </div>
</template>

<style scoped></style>
